import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import * as requests from '../api/requests';

import { addErrorNotification, addNotification } from './notificationsSlice';

const initialState = {};

export const handleResetPassword = createAsyncThunk(
  'resetPassword/handleResetPassword',
  async(email, thunkAPI) => {
    const res = await requests.handleResetPassword(email);
    const { ok } = res;
    const body = await res.json();

    if (ok) {
      thunkAPI.dispatch(addNotification('Password Has Been Reset Successfully, Check Your Email For The Temporary Password!'));
    } else {
      const errmsg = body.errmsg || 'Something Went Wrong When Resetting The Password!';
      thunkAPI.dispatch(addErrorNotification(errmsg));
    }

    return { ok, body };
  }
);

export const resetPasswordSlice = createSlice({
  name: 'resetPassword',
  initialState
});

export default resetPasswordSlice.reducer;
